<script type="text/javascript">
  import { mapGetters } from 'vuex';

  export default {
    props: {
      theme: {
        type: String,
        default: '',
      },
    },
    computed: {
      ...mapGetters('app', ['isLayoutDesktop']),
      classModifiers() {
        return {
          'market-widget-loader': true,
          [`market-widget-loader--${this.theme}`]: this.theme,
        };
      },
    },
  };
</script>

<template>
  <div :class="classModifiers" v-if="isLayoutDesktop">
      <div class="market-widget-loader__header">
        <div class="market-widget-loader__header-text"></div>
      </div>
      <div class="market-widget-loader__content">
        <template v-if="(theme === 'currently' || theme === 'comments')">
          <div class="market-widget-loader__avatarised">
            <div class="market-widget-loader__avatarised-item">
              <div class="market-widget-loader__avatarised-head">
                <div class="market-widget-loader__avatarised-avatar"></div>
                <div class="market-widget-loader__avatarised-title"></div>
              </div>
              <div class="market-widget-loader__avatarised-text"></div>
              <div class="market-widget-loader__avatarised-text"></div>
              <div class="market-widget-loader__avatarised-text market-widget-loader__avatarised-text--short"></div>
            </div>
            <div class="market-widget-loader__avatarised-item" v-if="theme === 'currently'">
              <div class="market-widget-loader__avatarised-head">
                <div class="market-widget-loader__avatarised-avatar"></div>
                <div class="market-widget-loader__avatarised-title"></div>
              </div>
              <div class="market-widget-loader__avatarised-text"></div>
              <div class="market-widget-loader__avatarised-text"></div>
              <div class="market-widget-loader__avatarised-text market-widget-loader__avatarised-text--short"></div>
            </div>
          </div>
        </template>
        <template v-if="theme === 'money'">
          <div class="market-widget-loader__simple">
            <div class="market-widget-loader__simple-text market-widget-loader__simple-text--large"></div>
            <div class="market-widget-loader__simple-text"></div>
            <div class="market-widget-loader__simple-text"></div>
            <div class="market-widget-loader__simple-text market-widget-loader__simple-text--short"></div>
          </div>
        </template>
        <template v-if="theme === 'stats'">
          <div class="market-widget-loader__stats">
            <div class="market-widget-loader__simple">
              <div class="market-widget-loader__simple-text market-widget-loader__simple-text--large"></div>
              <div class="market-widget-loader__simple-text"></div>
              <div class="market-widget-loader__simple-text"></div>
              <div class="market-widget-loader__simple-text market-widget-loader__simple-text--short"></div>
            </div>
            <div class="market-widget-loader__simple">
              <div class="market-widget-loader__simple-text market-widget-loader__simple-text--large"></div>
              <div class="market-widget-loader__simple-text"></div>
              <div class="market-widget-loader__simple-text"></div>
              <div class="market-widget-loader__simple-text market-widget-loader__simple-text--short"></div>
            </div>
          </div>
        </template>
      </div>
  </div>
</template>

<style lang="scss">
  @import '~styles/settings';

  .market-widget-loader {
    background: $white;
    height: 260px;

    &__header {
      background: $blue1;
      padding: 9px;
      width: 100%;
      height: 34px;

      &-text {
        @include text-line(123px, 15px);
      }
    }

    &--currently {
      margin-bottom: 8px;
    }

    &__simple {
      padding: 30px 10px 0;

      &-text {
        margin: 10px 0;

        @include text-line(100%, 9px);

        &--large {
          @include text-line(100%, 50px);
        }

        &--short {
          @include text-line(120px, 9px);
        }
      }
    }

    &__stats {
      display: flex;
      justify-content: space-between;

      & > div {
        width: 50%;
      }
    }

    &__avatarised {
      display: flex;
      justify-content: space-between;
      padding: 30px 22px 0;

      &-head {
        display: flex;
        align-items: center;
      }

      &-avatar {
        background: url('~assets/images/transition/widget-avatar.svg');
        width: 62px;
        height: 62px;
        background-size: contain;
      }

      &-title {
        @include text-line(123px, 9px);

        margin-left: 10px;
      }

      &-text {
        margin: 10px 0;

        @include text-line(250px, 9px);

        &--short {
          @include text-line(120px, 9px);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/content-loader/MarketWidgetLoader.vue